/*eslint no-unused-vars:0 */
import $ from "jquery";
import Swiper from "swiper/dist/js/swiper.min";

export default {
  init() {
    this.initFilterTabs();
    this.initSlider();
    this.doSidebarThings();
  },
  initFilterTabs() {
    const filterTabs = $(".filter-sidebar h3");
    // filterTabs.each(function(index) {
    //   if (index == 0) {
    //     return;
    //   } else {
    //     $(this)
    //       .next()
    //       .hide();
    //   }
    // });
    filterTabs.on("click", function() {
      const currentTab = $(this);
      const filterItems = currentTab.next();

      currentTab.toggleClass("open");
      filterItems.slideToggle("fast");
    });

    const archiveSidebarButton = document.getElementById(
      "sidebar-archive-button"
    );
    const currentPage = window.location.pathname
      .split("/")
      .filter(x => x)
      .slice(-1)[0];
    switch (currentPage) {
      case "couture":
        archiveSidebarButton.setAttribute("href", "/contact");
        archiveSidebarButton.innerText =
          "Book appointment to custom make a design →";
        break;
      case "bridal":
        archiveSidebarButton.setAttribute("href", "/she-said-yes");
        archiveSidebarButton.innerText = "They said yes with Glaudi Bridal →";
        break;
      default:
        archiveSidebarButton
          ? (archiveSidebarButton.parentNode.parentNode.style.display = "none")
          : null;
    }
  },
  initSlider() {
    let sliderContainer = document.querySelector(".intro-slider");
    if (sliderContainer) {
      let introSlider = new Swiper(".intro-slider", {
        // Optional parameters
        loop: true,
        autoplay: {
          delay: 4500,
        },
        // If we need pagination
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
        // Navigation arrows
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // And if we need scrollbar
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
          snapOnRelease: true,
        },
      });
    }
  },
  doSidebarThings() {
    // If there are no filters or things inside the sidbebar, dont show it up.
    const sidebar = document.querySelector(".filter-sidebar");

    if (sidebar && sidebar.children.length <= 1) {
      sidebar.classList.add("hide");
      let productGrid = document.querySelector(".product-grid");
      productGrid.style.setProperty("margin", "0 auto");
    }

    // hide only the categories widget when not on swag
    const categoryFilterWidget = document.querySelector(
      ".widget_wcapf-category-filter"
    );
    if (
      !document.querySelector("body").classList.contains("term-glaudi-swag")
    ) {
      categoryFilterWidget.classList.add("hide");
    }

    let mobileMQ = window.matchMedia("(max-width: 599px)");
    // Make the 'SHOW FILTERS' button for mobile work
    if (mobileMQ.matches) {
      const widgets = document.querySelectorAll(
        ".woocommerce-widget-layered-nav, .wcapf-ajax-term-filter"
      );
      const showFiltersButton = document.getElementById("button-show-filters");

      Array.prototype.forEach.call(widgets, (el, i) => {
        el.style.display = "none";
        // el.classList.add('hide');
      });

      showFiltersButton.addEventListener("click", e => {
        // let hidden = Array.prototype.every.call(widgets, el => el.classList.contains('hide'));
        let hidden = Array.prototype.every.call(
          widgets,
          el => el.style.display == "none"
        );
        if (hidden) {
          Array.prototype.forEach.call(widgets, el => {
            el.style.display = "block";
            // el.classList.remove('hide');
          });
        } else {
          Array.prototype.forEach.call(widgets, el => {
            // el.classList.add('hide');
            el.style.display = "none";
          });
        }
      });
    }
  },
};

/*

let introSlider = new Swiper ('.intro-slider', {
        init: false,
        // Optional parameters
        loop: true,

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true,
          snapOnRelease: true,
        },
        on: {
          init: function() {
            // let bodyWidth   = $('body').width()
            // let slideWidth = Math.round( bodyWidth * 0.8 )
            // let slideTitle  = $('.intro-slider .swiper-slide__title')

            //     slideTitle.css({
            //       right: bodyWidth - slideWidth,
            //       left: 'unset',
            //     })
          },
        },
      })

*/



// WEBPACK FOOTER //
// ./scripts/routes/archive.js